export enum NotificationType {
  PackingSlip = 'PackingSlip',
}

export interface NotificationPayload {
  deliveryDate: string;
  orderNumber: string;
  packingSlipNumber: string;
}

export interface NotificationModel {
  _id: string;
  accountId: string;
  type: NotificationType;
  payload: NotificationPayload;
  createdAt: string;
  readAt?: string;
}

export interface NotificationMeta {
  page: number;
  take: number;
  totalItems: number;
}

export interface NotificationResponse {
  meta: NotificationMeta;
  notifications: NotificationModel[];
}

export interface NotificationSettings {
  order_shipped: boolean;
}
